import {
  Component,
  ChangeDetectionStrategy,
  OnChanges,
  Input,
  ChangeDetectorRef,
  SimpleChanges,
  Output,
  EventEmitter,
} from "@angular/core";
import { environment } from "../../../environments/environment";
import { MzToastService } from "ng2-materialize";
import { PlanningPokerService } from "../../services/planning-poker/planning-poker.service";

@Component({
  selector: "app-voting",
  templateUrl: "./voting.component.html",
  styleUrls: ["./voting.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VotingComponent implements OnChanges {
  readonly env: any = environment;

  @Input() id: any;
  @Input() consensus: any;
  @Input() consensusTitle: string;
  @Input() votings: any;
  @Input() hideResults: boolean = false;

  @Output() consensusChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onChanges: EventEmitter<any> = new EventEmitter<any>();

  consensusEditValue: any;
  isConsensusEditingActive: boolean;

  constructor(
    private toastService: MzToastService,
    public planningPokerService: PlanningPokerService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    planningPokerService.estimationSet.subscribe((_) =>
      changeDetectorRef.markForCheck()
    );
    planningPokerService.participantJoined.subscribe((_) =>
      changeDetectorRef.markForCheck()
    );
    planningPokerService.participantLeft.subscribe((_) =>
      changeDetectorRef.markForCheck()
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["id"]) {
      this.isConsensusEditingActive = false;
      this.consensusEditValue = this.consensus;
      this.changeDetectorRef.markForCheck();
    }
  }

  canStartVoting() {
    return !this.planningPokerService.planningOpen;
  }

  isCurrentlyVoting() {
    return (
      this.planningPokerService.currentFeatureId === this.id &&
      this.planningPokerService.planningOpen
    );
  }

  async startVoting() {
    if (this.id) {
      await this.planningPokerService.startEstimation(this.id);
      this.votings.push({
        participants: [],
        consensus: this.consensus,
        average: null,
        median: null,
        agreement: null,
        variation: null,
      });
      this.onChanges.emit();
      this.changeDetectorRef.markForCheck();
      this.toastService.show("Schätzen gestartet!", 4000, "confirm-toast");
    }
  }

  async cancelVoting() {
    if (this.id) {
      if (await this.planningPokerService.stopEstimation(this.id)) {
        this.votings.pop();
        this.onChanges.emit();
        this.changeDetectorRef.markForCheck();
        this.toastService.show(
          "Schätzen abgebrochen!",
          4000,
          "notification-toast"
        );
      }
    }
  }

  async stopVoting() {
    if (this.id) {
      if (await this.planningPokerService.stopEstimation(this.id)) {
        this.isConsensusEditingActive = true;
        this.votings[
          this.votings.length - 1
        ].average = this.planningPokerService.average;
        this.votings[
          this.votings.length - 1
        ].median = this.planningPokerService.median;
        this.votings[
          this.votings.length - 1
        ].agreement = this.planningPokerService.agreement;
        this.votings[this.votings.length - 1].variation =
          (Math.sqrt(
            Array.from(this.planningPokerService.participants.values())
              .filter((x) => this.xIsNumber(x.estimation))
              .map((x) =>
                Math.pow(
                  parseFloat(x.estimation) - this.planningPokerService.average,
                  2
                )
              )
              .reduce((x, y) => x + y, 0) /
              Array.from(
                this.planningPokerService.participants.values()
              ).filter((x) => this.xIsNumber(x.estimation)).length
          ) /
            this.planningPokerService.average) *
          100;
        this.votings[this.votings.length - 1].variation = isNaN(
          this.votings[this.votings.length - 1].variation
        )
          ? "-"
          : this.votings[this.votings.length - 1].variation.toFixed(1) + " %";

        console.log(this.votings[this.votings.length - 1].variation);

        this.votings[this.votings.length - 1].participants = Array.from(
          this.planningPokerService.participants.values()
        ).map((x) => ({
          name: x.name,
          estimation: x.estimation,
        }));
        this.onChanges.emit();
        this.changeDetectorRef.markForCheck();
        this.toastService.show("Schätzen beendet!", 4000, "notification-toast");
      }
    }
  }

  async saveConsensus() {
    if (this.id) {
      if (
        !this.consensusEditValue ||
        (this.consensusEditValue >= 0 && this.consensusEditValue <= 9999)
      ) {
        this.isConsensusEditingActive = false;
        if (this.consensusEditValue)
          this.consensusEditValue =
            Math.round(this.consensusEditValue * 10) / 10;
        this.consensus =
          !this.consensusEditValue && this.consensusEditValue !== 0
            ? null
            : this.consensusEditValue;
        if (this.votings.length > 0)
          this.votings[this.votings.length - 1].consensus = this.consensus;
        this.consensusChange.emit(this.consensus);
        this.onChanges.emit();
        await this.planningPokerService.setConsensus(
          this.id,
          this.consensusEditValue
        );
      }
    }
  }

  setAverageAsConsensus(average: number) {
    this.consensus = this.consensusEditValue = average;
    this.saveConsensus();
  }

  setMedianAsConsensus(median: number) {
    this.consensus = this.consensusEditValue = median;
    this.saveConsensus();
  }

  setUserVoteAsConsensus(effort: any) {
    if (effort) {
      if (effort !== "pause" && effort !== "?") {
        this.consensus = this.consensusEditValue = effort;
        this.saveConsensus();
      }
    }
  }

  xIsNumber(x) {
    return !isNaN(parseFloat(x)) && isFinite(x) && x >= 0;
  }

  isNumber() {
    return (
      !isNaN(parseFloat(this.consensus)) &&
      isFinite(this.consensus) &&
      this.consensus >= 0 &&
      this.consensus <= 9999
    );
  }

  editConsensus() {
    this.isConsensusEditingActive = true;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/voting/voting.component.ts